import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'do_workers_have_access_external_contacts_outside_their'

export const dataPointDefinition = {
  retracedId: 'do_workers_have_access_external_contacts_outside_their',
  name: 'Do workers have access to external contacts outside of their direct chain of command that help to resolve complaints, gr',
  description:
    "The intent of this question is to understand if there are people or groups outside of the workers' direct chain of command that assist in resolving complaints, grievances, harassment or abuse cases. This is not about workers being able to freely contact an external entity if they wish, but rather th",
  meta: {
    slcpMeta: {
      key: 'gr-2',
      number: 'WI-GRI-5',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'gr-2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29100,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
